import React, { useState, useEffect } from "react";
import styles from "./IndustryRecognizedCredentials.module.scss";
import { getCDNImageUrl } from "@/utils/Common";

const US_CERTIFICATIONS = [
  {
    name: "ACD",
    imgSrc: getCDNImageUrl("acd.webp"),
    alt: "ACD",
    link: "https://www.acd-chem.com/",
  },
  {
    name: "SGS",
    imgSrc: getCDNImageUrl("SGS.webp"),
    alt: "SGS",
    link: `${getCDNImageUrl("SGS_ISO+9001_2015.pdf")}`,
  },
  {
    name: "FDA",
    imgSrc: getCDNImageUrl("FDA.JPG"),
    alt: "FDA",
  },
  {
    name: "DUNS",
    imgSrc: getCDNImageUrl("DUNS.webp"),
    alt: "DUNS",
    duns: true,
  },
  {
    name: "RSPO",
    imgSrc: getCDNImageUrl("RSPO.webp"),
    alt: "RSPO",
    link: "https://rspo.org/members/9-6076-25-000-00/",
  },
  {
    name: "WFFC",
    imgSrc: getCDNImageUrl("wffc.webp"),
    alt: "WFFC",
  },
  {
    name: "THOMAS",
    imgSrc: getCDNImageUrl("THOMAS.webp"),
    alt: "THOMAS",
    link: "https://www.thomasnet.com/profile/30982710?src=tnbadge",
  },
  {
    name: "HALAL",
    imgSrc: getCDNImageUrl("HALAL.webp"),
    alt: "HALAL",
  },
  {
    name: "KOSHER",
    imgSrc: getCDNImageUrl("KOSHER.webp"),
    alt: "KOSHER",
  },
];

const GLOBAL_CERTIFICATIONS = [
  {
    name: "SGS",
    imgSrc: getCDNImageUrl("SGS.webp"),
    alt: "SGS",
    link: `${getCDNImageUrl("SGS_ISO+9001_2015.pdf")}`,
  },
  {
    name: "One Star Export House",
    imgSrc: getCDNImageUrl("StarExportHouse.webp"),
    alt: "One Star Export House",
    link: getCDNImageUrl("certificate.pdf"),
  },
  {
    name: "FSSAI",
    imgSrc: getCDNImageUrl("fssai.webp"),
    alt: "FSSAI",
  },
  {
    name: "DUNS",
    imgSrc: getCDNImageUrl("DUNS.webp"),
    alt: "DUNS",
    duns: true,
  },
  {
    name: "HALAL",
    imgSrc: getCDNImageUrl("HALAL.webp"),
    alt: "HALAL",
  },
  {
    name: "KOSHER",
    imgSrc: getCDNImageUrl("KOSHER.webp"),
    alt: "KOSHER",
  },
  {
    name: "RSPO",
    imgSrc: getCDNImageUrl("RSPO.webp"),
    alt: "RSPO",
    link: "https://rspo.org/members/9-6076-25-000-00/",
  },
];

const FNB_CERTIFICATIONS = [
  {
    name: "SGS",
    imgSrc: getCDNImageUrl("SGS.png"),
    alt: "SGS",
    link: `${getCDNImageUrl("SGS_ISO+9001_2015.pdf")}`,
  },
  {
    name: "RSPO",
    imgSrc: getCDNImageUrl("RSPO.webp"),
    alt: "RSPO",
    link: "https://rspo.org/members/9-6076-25-000-00/",
  },
  {
    name: "FSSAI",
    imgSrc: getCDNImageUrl("FSSAI.png"),
    alt: "FSSAI",
  },
  {
    name: "FDA",
    imgSrc: getCDNImageUrl("FDA.webp"),
    alt: "FDA",
  },
  {
    name: "HALAL",
    imgSrc: getCDNImageUrl("Halal.webp"),
    alt: "HALAL",
  },
  {
    name: "KOSHER",
    imgSrc: getCDNImageUrl("K.webp"),
    alt: "KOSHER",
  },
  {
    name: "NON-GMO",
    imgSrc: getCDNImageUrl("NONGMO.webp"),
    alt: "NON-GMO",
  },
  {
    name: "USDA",
    imgSrc: getCDNImageUrl("USDA.webp"),
    alt: "USDA",
  },
];

const CircleIcon = ({
  duns = false,
  imgSrc,
  alt,
  onClick = () => {},
  clickable = false,
}) => {
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 800);
    };

    // Check on mount
    checkScreenSize();

    // Add resize listener
    window.addEventListener("resize", checkScreenSize);
    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);
  return (
    <div
      onClick={onClick}
      className={styles.circleIcon}
      style={clickable ? { cursor: "pointer" } : {}}
    >
      {/* Outermost circle - subtle border effect */}
      <div className={styles.outerCircle}>
        {/* Middle circle - subtle border effect */}
        <div className={styles.middleCircle}>
          {/* Innermost circle - main image container */}
          <div className={styles.innerCircle}>
            {/* Image in the center */}
            {duns ? (
              <>
                {isMobile ? (
                  <img src={imgSrc} alt={alt} className={styles.centerImage} />
                ) : (
                  <p
                    dangerouslySetInnerHTML={{
                      __html: `<iframe src="https://profiles.dunsregistered.com/TpTpmsSeal.aspx?Domain=elchemy.com&Directory=" id="TpTpmsSealIFrm" width="130px" height="130px" frameborder="0" scrolling="no" allowtransparency="true"></iframe>`,
                    }}
                    className={`${styles.centerImage} ${styles.dunsSeal}`}
                  />
                )}
              </>
            ) : (
              <img src={imgSrc} alt={alt} className={styles.centerImage} />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

function IndustryRecognizedCredentials(props) {
  const { globalVersion = false, fnbVersion = false } = props;
  const DATA = fnbVersion
    ? FNB_CERTIFICATIONS
    : globalVersion
    ? GLOBAL_CERTIFICATIONS
    : US_CERTIFICATIONS;
  return (
    <div
      className={`${styles.industryRecognizedCredentials} ${
        fnbVersion ? styles.fnbVersion : ""
      }`}
    >
      {/* Left Section */}
      <div className={styles.leftSection}>
        {/* Small heading */}
        {/* <h6>INDUSTRY RECOGNIZED CREDENTIALS</h6> */}
        {/* Big Heading */}
        <h2>
          Industry-Recognized
          <br />
          Credentials of Trust
        </h2>
      </div>
      {/* Right Section */}
      <div className={styles.rightSection}>
        {/* Single Row with all CircleIcons centered */}
        <div className={styles.row}>
          {DATA.map((cert, index) => (
            <CircleIcon
              key={index}
              duns={cert.duns}
              clickable={!!cert.link}
              onClick={() => {
                if (cert.link) {
                  window.open(cert.link, "_blank");
                }
              }}
              imgSrc={cert.imgSrc}
              alt={cert.alt}
            />
          ))}
          {/* <CircleIcon
            clickable={true}
            onClick={() => {
              window.open("https://www.acd-chem.com/", "_blank");
            }}
            imgSrc={getCDNImageUrl("acd.webp")}
            alt="ACD"
          />
          <CircleIcon
            clickable={true}
            onClick={() => {
              window.open(
                `${getCDNImageUrl("SGS_ISO+9001_2015.pdf")}`,
                "_blank"
              );
            }}
            imgSrc={getCDNImageUrl("SGS.webp")}
            alt="SGS"
          />
          <CircleIcon
            // clickable={true}
            // onClick={() => {
            //   window.open("https://www.acd-chem.com/", "_blank");
            // }}
            imgSrc={getCDNImageUrl("FDA.JPG")}
            alt="FDA"
          />
          <CircleIcon
            clickable={true}
            duns={true}
            onClick={() => {
              window.open(
                "https://dunsregistered.dnb.com/DunsRegisteredProfileAnywhere.aspx?Key1=3188418&PaArea=Email"
              );
            }}
            imgSrc={getCDNImageUrl("DUNS.webp")}
            alt="DUNS"
          />

          <CircleIcon
            clickable={true}
            onClick={() => {
              window.open(
                "https://rspo.org/members/9-6076-25-000-00/",
                "_blank"
              );
            }}
            imgSrc={getCDNImageUrl("RSPO.webp")}
            alt="RSPO"
          />

          <CircleIcon imgSrc={getCDNImageUrl("wffc.webp")} alt="wffc" /> */}
          {/* <CircleIcon imgSrc={getCDNImageUrl("ISO-9001.png")} alt="ISO" /> */}
          {/* <CircleIcon
            clickable={true}
            onClick={() => {
              window.open(
                "https://www.thomasnet.com/profile/30982710?src=tnbadge",
                "_blank"
              );
            }}
            imgSrc={getCDNImageUrl("THOMAS.webp")}
            alt="THOMAS"
          />
          <CircleIcon imgSrc={getCDNImageUrl("HALAL.webp")} alt="HALAL" />
          <CircleIcon imgSrc={getCDNImageUrl("KOSHER.webp")} alt="KOSHER" /> */}
        </div>
      </div>
    </div>
  );
}

export default IndustryRecognizedCredentials;
